import { render, staticRenderFns } from "./ParagraphLoading.vue?vue&type=template&id=5ddef5df"
import script from "./ParagraphLoading.vue?vue&type=script&lang=ts"
export * from "./ParagraphLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports